import * as React from 'react';

const Bell = ({ style, width }) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 40 40"
    version="1.1"
    style={style}
  >
    <g
      id="notifications"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Growler-Notifications"
        transform="translate(-100.000000, -729.000000)"
      >
        <g id="max-cha-width" transform="translate(80.000000, 689.000000)">
          <g id="Group-3">
            <g
              id="Icons/Tertiary/Alert"
              transform="translate(20.000000, 40.000000)"
            >
              <g id="Page-1">
                <path
                  d="M20,0 C31.0457407,0 40,8.95425926 40,20 C40,31.0457407 31.0457407,40 20,40 C8.95425926,40 0,31.0457407 0,20 C0,8.95425926 8.95425926,0 20,0"
                  id="Fill-1"
                  fill="#EAEAE9"
                />
                <path
                  d="M19.7530926,12.7160556 C19.7530926,12.7160556 25.6790185,12.9629074 25.6790185,18.6419815 L25.6790185,23.2099444 L26.5432778,25.3086481 L12.592537,25.3086481 L13.8271667,22.4692037 L13.8271667,17.5308704 C13.8271667,17.5308704 15.1851296,12.7160556 19.7530926,12.7160556"
                  id="Fill-3"
                  fill="#FFFFFF"
                />
                <path
                  d="M19.8117037,29.7242037 C20.9061481,29.7242037 21.7935556,28.8367963 21.7935556,27.7423519 L17.8298519,27.7423519 C17.8298519,28.8367963 18.7172593,29.7242037 19.8117037,29.7242037"
                  id="Fill-5"
                  fill="#757575"
                />
                <path
                  d="M14.3296296,24.7211481 L14.857037,24.2063333 L14.857037,18.8239259 C14.857037,16.0920741 17.0798148,13.8691111 19.8116667,13.8691111 C22.5435185,13.8691111 24.7662963,16.0920741 24.7662963,18.8239259 L24.7662963,24.1955926 L25.3035185,24.7211481 L14.3296296,24.7211481 Z M20.7977778,11.9657778 L20.7977778,10.875963 C20.7977778,10.340037 20.3633333,9.90540741 19.8272222,9.90540741 C19.2911111,9.90540741 18.8564815,10.340037 18.8564815,10.875963 L18.8564815,11.9607778 C15.4831481,12.4292963 12.8751852,15.3244815 12.8751852,18.8239259 L12.8751852,23.3711481 L12.6457407,23.5946667 C11.707963,24.5081852 11.8290741,25.2920741 11.9848148,25.6772593 C12.1087037,25.983 12.5392593,26.6972593 13.8757407,26.703 L25.7572222,26.703 C27.087963,26.703 27.5224074,25.9868889 27.6472222,25.680037 C27.8040741,25.2939259 27.9268519,24.5102222 26.9883333,23.5967037 L26.7483333,23.3615185 L26.7483333,18.8239259 C26.7483333,15.3342963 24.1557407,12.4467037 20.7977778,11.9657778 Z"
                  id="Fill-7"
                  fill="#757575"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Bell;



// WEBPACK FOOTER //
// ./src/components/Icons/Bell.js